import { Button, Checkbox, Tooltip } from 'antd';
import React from 'react';

export interface PobTransitionControlsProps {
	enabled: boolean;
	passengerCount: number;
	selectedCount: number;
	actionLabel: string;
	tooltip: string;
	loading?: boolean;
	onSelectAll: (selected: boolean) => void;
	onAction: () => void;
}

const PobTransitionControls: React.FC<PobTransitionControlsProps> = (props) => {
	if (!props.enabled) return null;

	const allSelected = props.passengerCount > 0 && props.selectedCount === props.passengerCount;
	const someSelected = props.selectedCount > 0 && !allSelected;

	return (
		<div className='mc-qm-transition-controls'>
			<Checkbox
				aria-label='Select all passengers'
				checked={allSelected}
				indeterminate={someSelected}
				disabled={props.passengerCount === 0}
				onChange={(event) => props.onSelectAll(event.target.checked)}
			>
				Select all
			</Checkbox>
			<Tooltip title={props.tooltip}>
				<span className='mc-qm-transition-button-wrapper'>
					<Button
						type='primary'
						size='small'
						disabled={props.passengerCount === 0}
						loading={props.loading}
						onClick={props.onAction}
					>
						{props.selectedCount > 0
							? props.actionLabel
							: `${props.actionLabel} All`}
					</Button>
				</span>
			</Tooltip>
		</div>
	);
};

export default PobTransitionControls;
